<template>
<li class="treeViewItem">
  <div :class="isFolder?'bold':''" @click="toggle" @dblclick="changeType">
      <router-link v-if="!model.id&&model.link"
      :to="{path: '/avatamsaka/version/' + nowVer
        + '/sutra/' + nowSutra + '/detail/' + model.link}">
        {{ model.link }} {{ model.name }}
      </router-link>
    <span v-if="!model.id&&!model.link">
      {{ model.name }}
    </span>
    <span v-if="model.id"
    :to=
      "{path: '/avatamsaka/version/'
      + nowVer + '/sutra/' + nowSutra + '/' + model.link + '/' + model.id}"
    >
      {{ model.id }} {{ model.name }}
    </span>

    <i class="fa" v-if="isFolder">
      {{open ? `&#xf146;` : `&#xf0fe;`}}
    </i>
  </div>
  <ul v-show="open" v-if="isFolder">
    <treeItem class="item" v-for="(model, index) in model.children" :key="index"
    :model="model" :nowVer="nowVer" :nowSutra="nowSutra">
    </treeItem>
  </ul>
</li>
</template>
<script>
export default {
  name: 'treeItem',
  data() {
    return {
      open: true,
    };
  },
  props: {
    model: {
      type: [Object, String],
    },
    nowVer: {
      type: [String, Number],
    },
    nowSutra: {
      type: [String, Number],
    },
  },
  mounted() {},
  computed: {
    isFolder() {
      return this.model.children &&
        this.model.children.length;
    },
  },
  methods: {
    toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
    },
    changeType() {
      if (!this.isFolder) {
        this.$set(this.model, 'children', []);
        this.open = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.treeViewItem {
    color: #2A3F11;
    list-style: none;
    padding-top: 0.4em;
    > ul {
        margin-top: 0.5em;
        border-left: solid 2px #417505;
        padding-left: 0;
        margin-left: 0.6em;
        > li {
            border-left: solid 4px #96C560;
            padding-left: 20px;
        }
    }
    a:link {
        color: #2A3F11;
    }
    a:hover {
        color: #78b136;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TreeView/TreeView.vue